import { BehaviorSubject } from 'rxjs';
export const getBaseTableFilterStore = (getInitialState) => () => {
    const subject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => subject.subscribe(callback);
    const getState = () => subject.getValue();
    const setState = (data) => subject.next(data);
    const reset = () => subject.next(getInitialState());
    return {
        getInitialState,
        subscribe,
        getState,
        setState,
        reset
    };
};
